import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { view } from '@yola/ws-sdk';
import topbar from 'src/js/modules/topbar';

function ToolsContainer({ scrollTop, topbarHeight = 0, children = null }) {
  const position = -scrollTop;

  return (
    <div className="tools" style={{ top: topbarHeight }}>
      <div className="tools-inner" style={{ transform: `translate3d(0, ${position}px, 0)` }}>
        {children}
      </div>
    </div>
  );
}

ToolsContainer.propTypes = {
  scrollTop: PropTypes.number.isRequired,
  topbarHeight: PropTypes.number,
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({
  scrollTop: view.selectors.getScrollPosition(state),
  topbarHeight: topbar.selectors.getHeight(state),
});

export default connect(mapStateToProps)(ToolsContainer);
